/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'arrow-right': {
    width: 7,
    height: 12,
    viewBox: '0 0 7 12',
    data: '<path pid="0" d="M6.998 5.942a1.002 1.002 0 00-.286-.638L1.914.354a1.11 1.11 0 00-.76-.352 1.13 1.13 0 00-.8.268 1.01 1.01 0 00-.353.729c-.01.278.1.547.305.748L4.429 6 .306 10.253a.999.999 0 00-.305.748c.009.279.137.541.353.729.217.188.505.284.8.268a1.11 1.11 0 00.76-.353l4.798-4.949a.996.996 0 00.286-.754z" _fill="#BECD47"/>'
  }
})
